<template>
  <v-btn
   :icon="icon"
    rounded
    :height="isMobile() && !icon ? 35 : 30"
    :block="isMobile() && !icon"
    :outlined="isMobile() && !icon"
    :depressed="!isMobile()"
    @click="visualizarLocalizacao()"
    title="Localização"
    :disabled="cliente.latitude == '' || cliente.longitude == ''"
    ><slot></slot></v-btn
  >
</template>

<script>
export default {
  props: {
    cliente: Object,
    icon: Boolean
  },
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
    visualizarLocalizacao() {
      window.open(
        `https://www.google.com.br/maps/search/${this.cliente.latitude},${this.cliente.longitude}/data=!3m1!1e3`,
        "_blank"
      );
    },
  },
};
</script>

<style>
</style>